import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import u from 'updeep';
import isEqual from 'lodash/isEqual';
import { withRouter } from "react-router-dom";
import Dropdown from '../Dropdown';
import Img from '../Img';
import Link from '../Link';
import Menu from '../Menu';
import SvgIcon from '../SvgIcon';
import LazyFontLoader from '../LazyFontLoader';
import Loader from '../Loader';
import MenuLink from '../MenuLink';
import { isTextRtl } from '../../lib/appHelpers';
import Button from '../Button';
import Stat from '../Stat';
import onClickOutside from 'react-onclickoutside';
import {
  fetchBookWorkflow,
  fetchNextReadBooksWorkflow,
  fetchBookAssetsWorkflow,
  openGlobalBookReader,
  openGlobalQuickView,
  removeBookFromBookshelfWorkflow,
  getBookshelfListWorkflow,
  addBookshelfWorkflow,
  addNewBookToBookshelfWorkflow,
  getBookshelfAutocompletefWorkflow,
  fetchExtendedBookWorkflow,
} from '../../redux/bookActions';
import {
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  isAvailableOffline,
  saveOfflineTranslationsWorkflow,
  isTranslationAvailable,
  getOfflineBooksCount
 } from '../../redux/offlineBooksActions';
import { fetchCheckTranslationsMobileTranslateWorkflow, fetchMobileTranslationsWorkflow } from '../../redux/allMobileTranslateActions';
import { openAuthModal, fetchMeWorkflow, fetchUserListsWorkflow } from '../../redux/userActions';
import { openTranslationModal, fetchCheckTranslationsWorkflow } from '../../redux/translateActions';
import { setStoryStatusFn } from '../../redux/allFluencesActions';
import { flpSetStoryStatusFn } from '../../redux/flpHomeActions';
import { imageSrcsetSizes, MAX_OFFLINE_BOOKS_COUNT, links, sectionClicked, gaEventCategories, gaEventActions, gaReadSource, userAuthStages, gaEventLabel, roles as availableRoles , emergentReaderLevel , siteLocale } from '../../lib/constants';
import { getImageSize } from '../../lib/images';
import { addSlimNotification } from '../../redux/slimNotificationActions';
import { addOfflineBookModal } from '../../redux/offlineBookModalAction';
import { addNotificationModal, removeNotificationModal  } from '../../redux/notificationModalActions';
import { loginPolicy } from '../../lib/policymanager/index';
import { openFlpEnrolModal } from '../../redux/flpHomeActions';

import './BookCard.scss';

const Joyride = lazy(() => import('react-joyride'))
const SelectBookShelf = lazy(() => import('../Book/SelectBookShelf'))
const NoSpaceForMoreOfflineBooksModal = lazy(() => import('../Book/NoSpaceForMoreOfflineBooksModal'))
const PdfReader = lazy(() => import('../PdfReader'))

const getIsAddedToBookshelf = (book, lists) => {
  if (!lists) {
    return false;
  }
  let flag = false
  lists.forEach(item=>{
    if(item.books && item.books.find(b => b.slug === book.slug)){
      flag = true
    }
  })
  return flag
};


const getIsAddingToBookshelf = (slug, isAddingOrRemovingFromBookshelf) => {
  return isAddingOrRemovingFromBookshelf.includes(slug);
};

const getMetaEls = (arr, baseClassName) => {
  if (!arr  || arr.length === 0)
    return null;

  let names = arr.map(a => {
    return (a.name ? a.name : a)
  })
  names = names.sort();
  if (names.length === 0)
    return null;

    return (<span className={`${baseClassName}__names`}>
              { names.length === 1
                ?
                names[0]
                :
                `${names[0]} & ${names.length - 1} more`
              }
            </span>)
};


const MenuEl = ({baseClassName, 
  menu, 
  disabled, 
  viewport, 
  book, 
  onMenuButtonClick, 
  t, 
  hideMenu,
  hideQuickViewBtn,
  shouldShowReadIcon,
  showReadIconLoader,
  isFetchingAssets,
  isListenIconClicked,
  onAudioReadIconClicked,
  isReadIconClicked,
  onBookReadIconClicked,
  onResourceIconClicked,
  showTranslateButton,
  isFromMobileTranslate,
  isDraftLoading,
  showOverlay,
  showEmbedHoverIcons,
  closeOverlay,
  isCheckingTranslations,
  isCheckingMobileTranslations,
  onSaveForOfflineTranslate,
  isSavingOfflineTranslations,
  isTranslateOfflineClicked,
  hideReadalong,
  hideAllIcons,
  userId,
  userType,
  readSource,
  eventCategory,
  linkLoading,
  resource,
  eventLabel
  }) => {


    const bookCardClasses = {
      [`${baseClassName}__menu`]: !hideAllIcons,
      [`${baseClassName}__embed-menu`]: showEmbedHoverIcons,
      [`${baseClassName}__menu--hover`]: linkLoading,
      [`${baseClassName}__menu--hide-menu`]: hideMenu,
      [`${baseClassName}__menu--mobile-translate`]: showOverlay,
    }

    const quickMenuClasses = {
      [`${baseClassName}__quick-menu`]: true,
      [`${baseClassName}__quick-menu--hide`]: hideQuickViewBtn
    }

    const menuLinkEl = (
      <Link
        parentClassName={`${baseClassName}__dropdown-link`}
        theme="light"
      >
        <div className={`${baseClassName}__icon`}>
          <SvgIcon name="dots" title={t('SvgTitle.dots')}/>
        </div>
      </Link>
    );

    const { isGif } = book;

    const menuDropdownEl = (
      <Dropdown
        parentClassName={`${baseClassName}__dropdown`}
        toggleEl={menuLinkEl}
        noPadding
        disabled={disabled}
        closeOnClick={readSource === gaReadSource.embed}
        >
        {menu}
      </Dropdown>
    );

    const readAlongEl = (
     (isFetchingAssets && isListenIconClicked)
      ?
      <Loader size='m' />
      :
      <Link onClick={onAudioReadIconClicked} theme='light'>
        <SvgIcon name= 'readalong' size="m" pushRight/>
      </Link>
    );

    const onQuickViewEvents = () => {
      if (!showTranslateButton || !isFromMobileTranslate ) {
        if (readSource === gaReadSource.storyDetailsPage) {
          window.dataLayer.push({
            'event': gaEventActions.clickedQuickView,
            'category': readSource,
            'label': gaEventLabel.youMayLike,
            'item_type': gaEventLabel.book,
            'item_id': book.id,
            'item_value': book.title, 
            'user_id': userId,
            'user_profile': userType
          }) 
        }
        else {
          window.dataLayer.push({
            'event': gaEventActions.clickedQuickView,
            ...(eventCategory && {'category': eventCategory}),
            'label': eventLabel || readSource,
            'item_type': gaEventLabel.book,
            'item_id': book.id,
            'item_value': book.title, 
            'user_id': userId,
            'user_profile': userType
          }) }
        }
     
    }

    return (
      <div className={classNames(bookCardClasses)}>
        {
          (viewport.large || showOverlay || showEmbedHoverIcons) && !hideAllIcons
          ?
          <div className={`${baseClassName}__quick-menu-wrapper`}>
            <div className={classNames(quickMenuClasses)}>
              <Button 
                parentClassName={`${baseClassName}__quick-menu-btn`}
                label={(showTranslateButton || isFromMobileTranslate) ? t('global.translate') : t('Book.quick-view')}
                onClick={() => {
                  onMenuButtonClick(book);
                  if(!(showTranslateButton || isFromMobileTranslate)){
                    onQuickViewEvents();
                  }
                }}
                size="s"
                loaderSize={"s"}
                alignIconCenter={isFromMobileTranslate}
                loading={linkLoading || (showTranslateButton && isCheckingTranslations && !isTranslateOfflineClicked) || (isFromMobileTranslate && (isCheckingMobileTranslations || isDraftLoading))}
              />
              {!isFromMobileTranslate && !hideMenu && menuDropdownEl}
            </div>
            { !isFromMobileTranslate && (book.isAudio || isGif || shouldShowReadIcon || resource)
              ?
              <div className={`${baseClassName}__hover-controls`}>
                {
               (isFetchingAssets && isReadIconClicked) 
                  ?
                  <Loader size='m' />
                  :
                  <Link onClick={onBookReadIconClicked} theme='light'>
                    <SvgIcon name={ isGif ? 'gif' : 'read' } size="m" pushRight/>
                  </Link>
                }
                { book.isAudio && !hideReadalong ? readAlongEl : null }
                { resource &&  <Link onClick={onResourceIconClicked} theme='light' parentClassName={`${baseClassName}__resource-icon`}>
                    <SvgIcon name='resource' title={t("global.resources")} size="xm" pushRight/>
                  </Link>}
              </div>
              :
              null
            }
            {
              showTranslateButton
              ?
              <div className={`${baseClassName}__save-for-translate-btn`}>
                <Link onClick={onSaveForOfflineTranslate} theme='light' noTextDecoration>
                  { isSavingOfflineTranslations ? <Loader size="s" /> : t('global.save-for-offline-translate')}
                </Link>
              </div>
              :
              null
            }
            {
              isFromMobileTranslate
              ?
              <div className={`${baseClassName}__save-for-translate-btn`}>
                <fieldset className={`${baseClassName}__custom-fieldset`}>
                  <legend className={`${baseClassName}__custom-legend`}>{"or"}</legend>
                  <Link onClick={onBookReadIconClicked} theme='light' noTextDecoration>
                    { "Read the story"}
                  </Link>
                </fieldset>
              </div>
              :
              null
            }
          </div>
          :
          !isFromMobileTranslate && !hideAllIcons && menuDropdownEl
        }
      </div>
    )

};


const mapStateToProps = ({ book, offlineBooks, user: { isLoggedIn, profile, lists }, viewport, notification, windowDimensions, translate, network, flpHome, allMobileTranslate }) => ({
  isFetchingAssets: book.isFetchingAssets,
  isAddingOrRemovingFromBookshelf: book.isAddingOrRemovingFromBookshelf,
  offlineBooks,
  userEmail: profile.email,
  userId: profile.id,
  userType: profile.profile_type,
  online: network.online,
  roles: profile.roles,
  organizationRoles: profile.organizationRoles,
  isLoggedIn,
  profile,
  viewport,
  isSavingBookSlugs: offlineBooks.isSavingBookSlugs,
  windowDimensions: windowDimensions,
  isCheckingTranslations: translate.isCheckingTranslations,
  targetLanguage: translate.targetLanguage,
  isSavingTranslateBookSlugs: offlineBooks.isSavingTranslateBookSlugs,
  offlineTranslations: offlineBooks.translations,
  isCheckingMobileTranslations: allMobileTranslate.isCheckingMobileTranslations,
  isFetchingBookShelves: book.isFetchingBookShelves,
  bookShelfArr: book.bookShelfArr,
  userBookshelves: lists,
  isEmailConfirmed: profile.emailConfirmed,
  isLoading:book.isAddingToBookshelf,
  isFlpUserEnrolled: flpHome.isFlpUserEnrolled,
});

const mapDispatchToProps = {
  fetchBookWorkflow,
  fetchNextReadBooksWorkflow,
  fetchExtendedBookWorkflow,
  fetchBookAssetsWorkflow,
  openGlobalBookReader,
  openGlobalQuickView,
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  openAuthModal,
  removeBookFromBookshelfWorkflow,
  addOfflineBookModal,
  addSlimNotification,
  addNotificationModal,
  openTranslationModal,
  fetchCheckTranslationsWorkflow,
  fetchMobileTranslationsWorkflow,
  fetchCheckTranslationsMobileTranslateWorkflow,
  removeNotificationModal,
  setStoryStatusFn,
  flpSetStoryStatusFn,
  saveOfflineTranslationsWorkflow,
  getBookshelfListWorkflow,
  addBookshelfWorkflow,
  addNewBookToBookshelfWorkflow,
  getBookshelfAutocompletefWorkflow,
  fetchMeWorkflow,
  fetchUserListsWorkflow,
  openFlpEnrolModal,
};

@translate()
@connect(mapStateToProps, mapDispatchToProps)
@onClickOutside
class BookCard extends Component {
  static defaultProps = {
    shouldDisplayMenu: true
  }

  constructor(props){
    super(props);
    this.state = {
      isModalVisible: {
        noSpaceForMoreOfflineBooks: false,
        selectBookShelf: false
      },
      isListenIconClicked: false,
      isReadIconClicked: false,
      isListenLinkClicked: false,
      isReadLinkClicked: false,
      showJoyride: false,
      isTranslateOfflineClicked: false,
      showOverlay: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.showReadIconLoader, nextProps.showReadIconLoader)) {
      this.setState ({ isReadIconClicked: nextProps.showReadIconLoader })
    }
    if (!isEqual(this.props.isFetchingAssets, nextProps.isFetchingAssets) && !nextProps.isFetchingAssets) {
      this.setState ({ isReadIconClicked: false })
    }
    if (nextProps.offlineTranslations.length > this.props.offlineTranslations.length && this.state.isTranslateOfflineClicked){
      this.setState({ showJoyride: true, isTranslateOfflineClicked: false })
    }
  }
  handleClick = (e) => {
    if (this.props.disabled || this.props.loading) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      if (this.props.onClick) {
        // Since 'href' will be always be there for the card
        // disabled the defaults when onClick prop is present.
        e.preventDefault();
        this.setState({isReadIconClicked: true})
        this.props.onClick(e);
      }
    }
  }

  handleClickOutside = () => {
    if(this.state.showOverlay){
      this.setState({showOverlay: false})
    }
  }

  toggleOverlay = () => {
      this.setState({showOverlay : true})
  }

  onReadClicked = () => {
    const {
      book,
      fetchBookAssetsWorkflow,
      fetchNextReadBooksWorkflow,
      fetchExtendedBookWorkflow,
      openGlobalBookReader,
      readSource,
      offline,
      openAuthModal,
      isOfflineRp,
      flpBook,
      isSupplementary
    } = this.props;
    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
      if (loginPolicy.shouldShowMandatoryLogin() && !offline) {
        openAuthModal({
          stage: userAuthStages.mandatoryLogin
        })
      } else {
        fetchBookAssetsWorkflow(book.slug, false, false, false, flpBook, readSource==="stem")
        .then(openGlobalBookReader({book, isOfflineRp, flpBook: flpBook, isSupplementary: isSupplementary}))
        .then(() => {
          fetchExtendedBookWorkflow(book.slug)
          fetchNextReadBooksWorkflow(book.slug)
        })
        loginPolicy.storyRead(book.slug);
      }
    }
  }

  onBookReadIconClicked(secClicked, readSource) {
    const {
      book,
      fetchBookAssetsWorkflow,
      openGlobalBookReader,
      readingListNextReadBooks,
      userId,
      online,
      openAuthModal,
      offlineBooks,
      fetchNextReadBooksWorkflow,
      isOfflineRp,
      setStoryStatusFn,
      flpSetStoryStatusFn,
      flpBook,
      eventLabel,
      isSupplementary,
      skipLogin
    } = this.props;

    let offlineBook = {};
    const flpHomeBooks = offlineBooks.books.filter(book => userId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(userId, 10)))

    const readingProgramBooks = offlineBooks.books.filter(book => userId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(userId, 10)))

    if(flpBook) flpHomeBooks.map(offlineBookItem => {
       if(offlineBookItem.id === book.id && offlineBookItem.isFromFlpHome){
        offlineBookItem.enrolledUsers.forEach(item => {
          if(item.userId === userId || item.userId === parseInt(localStorage.getItem('userId'),10)){
            offlineBook.enrollmentId = item.enrollmentId;
            offlineBook.status = item.status;
            offlineBook.themeNumber = item.themeNumber;
            offlineBook.isFromFlpHome=true;
          }
        })
       }
      return true;
    })
    else {
      readingProgramBooks.map(offlineBookItem => {
        if(offlineBookItem.id === book.id && offlineBookItem.isFromReadingProgram){
          offlineBookItem.enrolledUsers.forEach(item => {
            if(item.userId === userId || item.userId === parseInt(localStorage.getItem('userId'),10)){
              offlineBook.enrollmentId = item.enrollmentId;
              offlineBook.status = item.status;
              offlineBook.themeNumber = item.themeNumber;
              offlineBook.isFromReadingProgram=true;
            }
          })
    
        }
        return true
      })
    }

    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
      if (!skipLogin && loginPolicy.shouldShowMandatoryLogin() && online) {
        openAuthModal({
          stage: userAuthStages.mandatoryLogin
        })
      } else {
        if ( secClicked === sectionClicked.bookCardIcon)
          this.setState({isReadIconClicked: true})
        else
          this.setState({isReadLinkClicked: true})

        if(this.props.overrideClick) {
          this.props.onClick()
        }
        else {
          fetchBookAssetsWorkflow(book.slug, false, false, false, flpBook, readSource==="stem")
            .then(() => {
              openGlobalBookReader({book, readingListNextReadBooks, readingProgramBook: offlineBook.isFromReadingProgram, storyId: book.id, themeNumber: offlineBook.themeNumber, enrollmentId: offlineBook.enrollmentId, readSource, isOfflineRp, flpBook, isSupplementary: isSupplementary});
            })
            .then(() => {
              fetchNextReadBooksWorkflow(book.slug)
            })
            .then(() => {
              this.setState({isReadIconClicked: false, isReadLinkClicked: false});

              if(offlineBook.status !== 'finished' && offlineBook.isFromReadingProgram && (readSource === gaReadSource.readingProgram || (readSource === gaReadSource.offlineLibrary && isOfflineRp))) {
                setStoryStatusFn(book.id, offlineBook.enrollmentId, offlineBook.themeNumber, 'continue');
              }

              if(offlineBook.status !== 'finished' && offlineBook.isFromFlpHome && readSource === gaReadSource.offlineLibrary && flpBook) {
                flpSetStoryStatusFn(book.id, offlineBook.enrollmentId, 'continue', book.locale)
              }
            });

        window.dataLayer.push({
          'event': gaEventActions.startReading,
          'category': this.props.eventCategory || readSource,
          'label': eventLabel ? eventLabel : (readSource === gaReadSource.storyDetailsPage ? gaEventLabel.youMayLike : readSource===gaReadSource.translatePage  ? gaEventActions.storyTile : readSource),
          'item_type': gaEventLabel.bookLangLevel,
          'item_id': book.id,
          'item_value': flpBook ? `${book.language}_${book.flpLevel.split(' ')[1]}` : `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`, 
          'user_id': this.props.userId,
          'user_profile': this.props.userType
        })

        loginPolicy.storyRead(book.slug);
      }
    }
    }
  }

  onAudioReadIconClicked(secClicked, readSource) {
    const {
      book,
      fetchBookAssetsWorkflow,
      openGlobalBookReader,
      readingListNextReadBooks,
      userId,
      online,
      openAuthModal,
      offlineBooks,
      fetchNextReadBooksWorkflow,
      isOfflineRp,
      flpBook,
      eventLabel,
      skipLogin
    } = this.props;

    let offlineBook = {};
    const flpHomeBooks = offlineBooks.books.filter(book => userId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(userId, 10)))

    const readingProgramBooks = offlineBooks.books.filter(book => userId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(userId, 10)))

    if(flpBook) flpHomeBooks.map(offlineBookItem => {
       if(offlineBookItem.id === book.id && offlineBookItem.isFromFlpHome){
        offlineBookItem.enrolledUsers.forEach(item => {
          if(item.userId === userId || item.userId === parseInt(localStorage.getItem('userId'),10)){
            offlineBook.enrollmentId = item.enrollmentId;
            offlineBook.status = item.status;
            offlineBook.themeNumber = item.themeNumber;
            offlineBook.isFromFlpHome=true;
          }
        })
       }
      return true;
    })
    else {
      readingProgramBooks.map(offlineBookItem => {
        if(offlineBookItem.id === book.id && offlineBookItem.isFromReadingProgram){
          offlineBookItem.enrolledUsers.forEach(item => {
            if(item.userId === userId || item.userId === parseInt(localStorage.getItem('userId'),10)){
              offlineBook.enrollmentId = item.enrollmentId;
              offlineBook.status = item.status;
              offlineBook.themeNumber = item.themeNumber;
              offlineBook.isFromReadingProgram=true;
            }
          })
    
        }
        return true
      })
      
    }

    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
      if (!skipLogin && loginPolicy.shouldShowMandatoryLogin() && online) {
        openAuthModal({
          stage: userAuthStages.mandatoryLogin
        })
      } else {
        if (secClicked === sectionClicked.bookCardIcon)
          this.setState({isListenIconClicked: true});
        else
          this.setState({isListenLinkClicked: true});
        
          if(this.props.overrideClick && this.props.onAudioClick) {
            this.props.onAudioClick()
          }
          else {
            fetchBookAssetsWorkflow(book.slug, true, false, false, flpBook, readSource==="stem")
            .then(() => {
              openGlobalBookReader({book, showAudioBookReader: true, readingListNextReadBooks, readingProgramBook: offlineBook.isFromReadingProgram, storyId: book.id, themeNumber: offlineBook.themeNumber, enrollmentId: offlineBook.enrollmentId, readSource, isOfflineRp, flpBook});
            })
            .then(() => {
                fetchNextReadBooksWorkflow(book.slug)
                this.setState({isListenIconClicked: false, isListenLinkClicked: false});
            });

            window.dataLayer.push({
              'event': gaEventActions.startedListening,
              'category': this.props.eventCategory || readSource,
              'label': eventLabel ? eventLabel : (readSource === gaReadSource.storyDetailsPage ? gaEventLabel.youMayLike : readSource===gaReadSource.translatePage  ? gaEventActions.storyTile : readSource),
              'item_type':'book_language_level',
              'item_id': book.id,
              'item_value': flpBook ? `${book.language}_${book.flpLevel.split(' ')[1]}` : `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`, 
              'user_id': this.props.userId,
              'user_profile': this.props.userType
            })
            loginPolicy.storyRead(book.slug);
          }        
      }
    }    
  }

  openPdfViewer = (pdf) => {
    if (pdf) {
      this.setState({ openPdf: true,  pdfFile: pdf})
    }
    else {
      this.setState({ openPdf: false })
    }
  }

  onResourceIconClicked = () => {
    const {
      userId,
      userType,
      openAuthModal,
      isLoggedIn,
      resource,
      openFlpEnrolModal,
      isFlpUserEnrolled,
      eventCategory,
      eventLabel,
      book,
      nag,
      flpBook
    } = this.props;

    window.dataLayer.push({
      'event': 'resource_clicked',
      'category': eventCategory,
      'label': eventLabel,
      'item_type':'book_language_level',
      'item_id': book.id,
      'item_value': flpBook ? `${book.language}_${book.flpLevel.split(' ')[1]}` : `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`, 
      'user_id': userId,
      'user_profile': userType
    })

    if(!isLoggedIn) {
      openAuthModal();
    }
    else if(!isFlpUserEnrolled && nag) {
      openFlpEnrolModal({
        nag: true,
        self: true,
        pdf: true,
      })
    }
    else {
      this.openPdfViewer(resource)
    }  
  }
  

  onBookDetailsClicked() {
    window.location.href = links.bookDetails(this.props.book.slug);
  }

  onClickLogin = () => {
    this.props.openAuthModal();
  }

  onAddToMyBookshelf = () => {
    const {
      isLoggedIn,
      profile,
      t,
      openAuthModal,
      addNotificationModal,
      removeNotificationModal,
    } = this.props;

    if (!isLoggedIn || !profile) {

      addNotificationModal({
        title: t("global.log-in"),
        content: t("BookCard.please-log-in-notification-text"),
        additionalActions: [{
          label: t('global.log-in'),
          primary: true,
          onClick: () => { removeNotificationModal(); openAuthModal(); }
        }, {
          label: t('global.sign-up'),
          onClick: () => { removeNotificationModal(); openAuthModal(); }
        }]
      })
    }
    else {
      window.dataLayer.push({
        event: 'clicked_bookshelf',
        category: this.props.readSource,
        label: gaEventActions.storyTile,
        item_type: null,
        item_id: null,
        item_value: null,
        user_id: this.props.profile.id,
        user_profile: this.props.profile.profile_type
      })
      this.setState(u({
        isModalVisible: {
          selectBookShelf: true
        }
      }, this.state));
    }
  }

  onRemoveFromMyBookshelf = () => {
    const {
      removeBookFromBookshelfWorkflow,
      book: { slug },
      addSlimNotification,
      t,
      userBookshelves,
      fetchUserListsWorkflow,
    } = this.props;

    let bookshelf;
    userBookshelves.forEach(item=>{
        if(item.books && item.books.find(b => b.slug === slug)){
          bookshelf = item.slug
        }
    })

    if (bookshelf) removeBookFromBookshelfWorkflow(slug, bookshelf)
          .then((res)=>{
            if(res.ok) {
              addSlimNotification({
                type: 'info',
                id: 'BookCard.removed-from-bookshelf-notification',
                content: t('BookCard.removed-from-bookshelf-notification-text'),
              })
              localStorage.setItem('sw-bookshelf', 'bookshelf' + Math.random());
              fetchUserListsWorkflow();
            }
            // localStorage.setItem('sw-bookshelf-activity', 'add-or-remove' + Math.random());
          });
  }

  onAddToOfflineClicked = (book) => {
    const {
      saveOfflineWorkflow,
      profile,
      addSlimNotification,
      t,
      windowDimensions
    } = this.props;

    saveOfflineWorkflow(book, getImageSize(windowDimensions.width), profile.id)
      .then(() => {
        addSlimNotification({
          type: 'info',
          content: book.isAudio ? t('Book.offline-audio-add-notification') 
            : t('Book.offline-add-notification')
        })
        localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
      })
      .then(() => {
        window.dataLayer.push({
          event: gaEventActions.saveOfflineLibrary,
          category: this.props.readSource,
          label: gaEventActions.storyTile,
          item_type: null,
          item_id: null,
          item_value: null,
          user_id: this.props.userId,
          user_profile: this.props.userType
        })
      } 
    );
  }

  onRemoveFromOfflineClicked = (book) => {
    const {
      unsaveOfflineWorkflow,
      addSlimNotification,
      t,
      windowDimensions
    } = this.props;

    // in offline mode, get userId from localStorage
    const profileId = this.props.profile.id || parseInt(localStorage.getItem('userId'), 10);
    unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId)
      .then(() => {
        addSlimNotification({
          type: 'info',
          content: t('Book.offline-delete-warning') 
        })
        localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
      })
      .then(() =>{
        window.dataLayer.push({
          event: gaEventActions.removeOfflineLibrary,
          category: this.props.readSource,
          label: gaEventActions.storyTile,
          item_type: null,
          item_id: null,
          item_value: null,
          user_id: this.props.userId,
          user_profile: this.props.userType
        })
      } 
    );
  }

  onOpenModal = (modalName) => {
    this.setState(u({
      isModalVisible: {
        [modalName]: true
      }
    }, this.state));
  }

  onCloseModal(modalName) {
    this.setState(u({
      isModalVisible: {
        [modalName]: false
      }
    }, this.state));
  }

  onTranslateBookClicked = (slug) => {
    const { 
      isLoggedIn,
      viewport,
      addSlimNotification,
      t, 
      book,
      userId,
      userType,
      roles,
      organizationRoles,
      targetLanguage, 
      fetchCheckTranslationsWorkflow,
      fetchMobileTranslationsWorkflow,
      fetchCheckTranslationsMobileTranslateWorkflow,
      openTranslationModal,
      isTargetLangAvailable,
      openAuthModal } = this.props;

    const isContentManager = roles && roles.includes(availableRoles.CONTENT_MANAGER)
    const isPublisher = organizationRoles && organizationRoles.includes(availableRoles.PUBLISHER)
    const isTranslationPartner = organizationRoles && organizationRoles.includes("translation_partner")
      
    if (!isLoggedIn) {
      openAuthModal();
      return;
    }

    if (!this.props.isEmailConfirmed) {
      addSlimNotification({
        id: "OTP.confirm-email-action",
        content: t('OTP.confirm-email-action', { action: t('global.translate-storybooks') })
      });
      return;
    }

    if (!targetLanguage) {
      document.getElementById("pb-translate-landing-to-lang").focus();
      addSlimNotification({
        id: 'Book.select-language-notification',
        type: 'danger',
        content: t('Book.select-language-notification'),
      });
      return;
    }
      if (!isTargetLangAvailable) {
      document.getElementById("pb-translate-landing-to-lang").focus();
      addSlimNotification({
        id: 'Book.select-language-notification',
        type: 'danger',
        content: t('Book.select-language-notification'),
      });
      return;
    }

    let el = document.getElementsByTagName("body")[0]

    if(viewport.medium) {
      if(el) {
        el.style.opacity = 0.5;
        el.style.pointerEvents = "none";
      }
      fetchCheckTranslationsWorkflow(book.slug, targetLanguage)
      .then(response => {
        if (response.ok) {
          if (response.data.length === 0) {
            window.dataLayer.push({
              event: gaEventActions.clickedTranslateNow,
              category: gaEventCategories.translateHome,
              label:gaEventActions.storyTile,
              item_type: gaEventLabel.bookLangLevel,
              item_id: book.id,
              item_value: `${targetLanguage}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`,
              user_id: userId,
              user_profile: userType
            })
            this.setState({linkLoading: true})
            window.location.href = links.translateBookToLanguage(slug, targetLanguage)
          }
          else {
            if(el) {
              el.style.opacity = 1;
              el.style.pointerEvents = "initial";
            }
            openTranslationModal(book);
          }
        }
      })
    }
    else {
      if(isContentManager || isPublisher || isTranslationPartner) {
        addSlimNotification({
          id: 'Book.mobile-editor-notification',
          content: t('Book.mobile-editor-cm-notification'),
        }) 
      }
      else {
        if(el) {
          el.style.opacity = 0.5;
          el.style.pointerEvents = "none";
        }
        fetchCheckTranslationsMobileTranslateWorkflow(book.slug, targetLanguage).then(res=>{
          if(res.ok){
            if(res.data.length === 0){
              window.dataLayer.push({
                event: gaEventActions.startTranslate,
                category: gaEventCategories.mobileTranslate,
                label:gaEventActions.storyTile,
                item_type: gaEventLabel.bookLangLevel,
                item_id: book.id,
                item_value: `${targetLanguage}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`,
                user_id: userId,
                user_profile: userType
              })
              fetchMobileTranslationsWorkflow(book.slug, targetLanguage).then(res=>{
                this.setState({linkLoading: true})
                window.location.href = links.mobileTranslateBook(res.data.parent_story_id, res.data.translated_story_id)
               })
            }
            else {
              if(el) {
                el.style.opacity = 1;
                el.style.pointerEvents = "initial";
              }
              openTranslationModal(book, null, true);
            }
          }
          else {
            if(el) {
              el.style.opacity = 1;
              el.style.pointerEvents = "initial";
            }
            addSlimNotification({
              id: 'Book translate',
              content: res.data.errorMessage,
            });
          }
        })
      }
    }
  }

  onSaveForOfflineTranslate = (book) => {
    const {
      t,
      isLoggedIn,
      targetLanguage,
      openAuthModal,
      addSlimNotification,
      windowDimensions,
      userId,
      saveOfflineTranslationsWorkflow,
      fetchCheckTranslationsWorkflow,
      openTranslationModal,
      isTargetLangAvailable,
      viewport,
      offlineTranslations,
    } = this.props
   
    if (!isLoggedIn) {
      openAuthModal();
      return;
    }

    if (!this.props.isEmailConfirmed) {
      addSlimNotification({
        id: "OTP.confirm-email-action",
        content: t('OTP.confirm-email-action', { action: t('global.translate-storybooks') })
      });
      return;
    }

    if (!targetLanguage) {
      document.getElementById("pb-translate-landing-to-lang").focus();
      addSlimNotification({
        id: 'Book.select-language-notification',
        type: 'danger',
        content: t('Book.select-language-notification')
      });
      return;
    }

    if (!isTargetLangAvailable) {
      document.getElementById("pb-translate-landing-to-lang").focus();
      addSlimNotification({
        id: 'Book.select-language-notification',
        type: 'danger',
        content: t('Book.select-language-notification'),
      });
      return;
    }

    if(isTranslationAvailable(book.id, offlineTranslations, userId, targetLanguage)) {
      addSlimNotification({
        id: 'Book.offline-draft-exists-notification',
        content: t('Book.offline-draft-exists-notification')
      });
      return;
    }
    else{
      this.setState({ isTranslateOfflineClicked: true })
      window.dataLayer.push({
        event: gaEventActions.clickedTranslateOffline,
        category: gaEventCategories.translateHome,
        label: gaEventActions.storyTile,
        item_type: null,
        item_id: null,
        item_value: null,
        user_id: userId,
        uer_profile: this.props.userType
      })
    }

    let offlineBook = Object.assign({}, book, {
    // to distinguish books saved for offline translate 
      isFromOfflineTranslate: true,
    })

    fetchCheckTranslationsWorkflow(book.slug, targetLanguage)
      .then(response => {
        if (response.ok) {
          if (response.data.length === 0) {
            if (viewport.medium) {
              saveOfflineTranslationsWorkflow(offlineBook, getImageSize(windowDimensions.width), userId, {targetLanguage: targetLanguage, content: []})
              .then((response) => {
                if(response && !response.ok) {
                  addSlimNotification({
                    type: 'danger',
                    content: 'The story could not be saved. Please try again later',
                  });
                  return;
                }
                
                localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
              })
            }
            else {
              addSlimNotification({
                id: 'Book.mobile-editor-notification',
                content: t('Book.mobile-editor-notification-text'),
              });
            }
          }
          else {
            openTranslationModal(book, sectionClicked.translatePage, true, true);
          }
        }
      })
  }

  onRecoCardClick = (secClicked) => {
    const {
      book,
      userId,
      userType,
      eventCategory,
      eventLabel,
      overrideClick,
      flpBook
    } = this.props;

    if(eventCategory && !overrideClick){
      window.dataLayer.push({
        'category': eventCategory,
        'label': eventLabel,
        'event':  eventLabel !== 'translate' ? gaEventActions.clickedStory : 'start_translation',
        'item_type': gaEventLabel.bookLangLevel,
        'item_id': book.id,
        'item_value': flpBook ? `${book.language}_${book.flpLevel.split(' ')[1]}` : `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`, 
        'user_profile': userType,
        'user_id': userId
      })
    }
  }

  handleJoyrideCallback = (data) => {
    if  (data.action === "close") {
      this.setState({ showJoyride: false })
    }
  }

  render() {
    const {
      book,
      t,
      userEmail,
      userId,
      fontSize,
      disabled,
      onClick,
      loading,
      shouldDisplayMenu,
      customMenu,
      isFetchingAssets,
      offline,
      openGlobalQuickView,
      offlineBooks,
      isLoggedIn,
      profile,
      openAuthModal,
      isAddingOrRemovingFromBookshelf,
      viewport,
      hideMenu,
      hideQuickViewBtn,
      shouldShowReadIcon,
      showReadIconLoader,
      hideReadCountStat,
      hideDeleteOfflineRpIcon,
      addNotificationModal,
      removeNotificationModal,
      hasOverlay,
      hasLightOverlay,
      showTranslateButton,
      isFromMobileTranslate,
      isCheckingTranslations,
      isSavingBookSlugs,
      isDraftLoading,
      readSource,
      isRtl,
      isSavingTranslateBookSlugs,
      offlineTranslations,
      isCheckingMobileTranslations,
      getBookshelfListWorkflow,
      addBookshelfWorkflow,
      addNewBookToBookshelfWorkflow,
      getBookshelfAutocompletefWorkflow,
      isFetchingBookShelves,
      bookShelfArr,
      addSlimNotification,
      userBookshelves,
      originalAuthors,
      isTranslation,
      isRelevelled,
      sectionClicked : secClicked,
      fetchUserListsWorkflow,
      hideReadalong,
      hideAllIcons,
      eventCategory,
      resource,
      flpBook,
      flpLevel,
      eventLabel,
      showEmbedHoverIcons,
    } = this.props;

    const {
      language,
      level,
      slug,
      coverImage,
      authors,
      illustrators,
      recommended,
      contest,
      awardsDetails,
      readsCount,
      isGif,
      created_by_children
    } = book;
    const title = book.name ? book.name : book.title;

    const profileId = profile.id || parseInt(localStorage.getItem('userId'), 10);
    
    const tab = book.isFromReadingProgram ? 'rp' : book.isFromFlpHome ? 'flpHome' : book.isFromStemHome ? 'stemHome' : 'read';
    const availableOffline = profileId && isAvailableOffline(book.id, offlineBooks, tab, profileId);
    
    const baseClassName = 'pb-book-card';
    let isAddedToBookshelf = false;
    
    isAddedToBookshelf =  getIsAddedToBookshelf(book, userBookshelves);

    const isAddingToBookshelf = getIsAddingToBookshelf(slug, isAddingOrRemovingFromBookshelf);
    let menu = null;

    const offlineTranslateBooksCountForUser = offlineTranslations.filter(translation => translation.userId === profile.id).length;
    const offlineReadBooksCountForUser = offlineBooks.books.filter(book => !book.isFromOfflineTranslate && book.savedUsers && book.savedUsers.includes(profile.id)).length;
    const offlineBooksCountForUser = offlineTranslateBooksCountForUser + offlineReadBooksCountForUser;
    const isAvailableForOfflineTranslate = isAvailableOffline(book.id, offlineBooks, 'translate');
    const isAvailableForOfflineRead = isAvailableOffline(book.id, offlineBooks, 'read');
    const offlineBooksCountForRead = getOfflineBooksCount(offlineBooksCountForUser, offlineBooks.books.length, isAvailableForOfflineRead)
    const offlineBooksCountForTranslate = getOfflineBooksCount(offlineBooksCountForUser, offlineBooks.books.length, isAvailableForOfflineTranslate)

    if (shouldDisplayMenu) {
      if(customMenu){
        menu = (
          <Menu isRtl={isRtl}>
            <MenuLink
              leftIcon={ isGif ? "gif" : "book" }
              isRtl={isRtl}
              onClick={() => this.onBookReadIconClicked('bookCardLink', readSource)}
              label={t("Book.read")}
              loading={isFetchingAssets && this.state.isReadLinkClicked}
              section="book-card"
            />
            {
              book.isAudio && !hideReadalong && <MenuLink
                leftIcon="readalong"
                isRtl={isRtl}
                onClick={() => this.onAudioReadIconClicked('bookCardLink', readSource)}
                label={t("Book.listen")}
                loading={isFetchingAssets && this.state.isListenLinkClicked}
              />
            }  
          </Menu>
        )
      }
      else{
        menu = (
          <Menu isRtl={isRtl}>
            <MenuLink
              leftIcon={ isGif ? "gif" : "book" }
              isRtl={isRtl}
              onClick={() => this.onBookReadIconClicked('bookCardLink', readSource)}
              label={t("Book.read")}
              loading={isFetchingAssets && this.state.isReadLinkClicked}
              section="book-card"
            />
            {
              book.isAudio && !hideReadalong && <MenuLink
                leftIcon="readalong"
                isRtl={isRtl}
                onClick={() => this.onAudioReadIconClicked('bookCardLink', readSource)}
                label={t("Book.listen")}
                loading={isFetchingAssets && this.state.isListenLinkClicked}
              />
            }
            {
              (!viewport.large || showTranslateButton) && !hideQuickViewBtn
              ?
              <MenuLink
                leftIcon="quick-view"
                isRtl={isRtl}
                onClick={() =>{
                  openGlobalQuickView(book, readSource, eventCategory ? eventCategory : readSource, this.props.isSupplementary);
                  window.dataLayer.push({
                    event: gaEventActions.clickedQuickView,
                    category: readSource,
                    label: gaEventActions.storyTile,
                    item_type: null,
                    item_id: null,
                    item_value: null,
                    user_id: this.props.userId,
                    user_profile: this.props.userType
                  })
                }}
                label={t("Book.quick-view")}
              />
              :
              null
            }
            {
              resource && <MenuLink
                leftIcon="resource"
                isRtl={isRtl}
                onClick={() => this.onResourceIconClicked()}
                label={t("global.resources")}
                title={t("global.resources")}
                parentClassName={`${baseClassName}__resource-menu--icon`}
              />
            }
            {
              (!isAddedToBookshelf && isLoggedIn) || !isLoggedIn
              ?
              <MenuLink
                leftIcon="plus-circle"
                isRtl={isRtl}
                onClick={()=>{
                  this.onAddToMyBookshelf();
                  window.dataLayer.push({
                    event: gaEventActions.clickedBookshelf,
                    category: this.props.eventCategory,
                    label: gaEventActions.bookShelf,
                    item_type: null,
                    item_id: null,
                    item_value: null,
                    user_id: userId,
                    user_profile: this.props.profile.profile_type
                  })
                }
}
                label={t("global.my-bookshelf")}
                loading={isAddingToBookshelf}
              />
              :
              <MenuLink
                leftIcon="bin"
                isRtl={isRtl}
                onClick={()=>{
                  this.onRemoveFromMyBookshelf();
                  window.dataLayer.push({
                    event: gaEventActions.bookDeleted,
                    category: this.props.eventCategory,
                    label: gaEventActions.bookShelf,
                    item_type: 'book',
                    item_id: book.id, 
                    item_value: null,
                    user_id: userId,
                    user_profile: this.props.profile.profile_type
                   })
                }
                }
                label={t("Book.remove-from-my-bookshelf")}
                loading={isAddingToBookshelf}
                theme="danger"
                section="book-card"
              />
            }
            {
              ('serviceWorker' in navigator)
              ?
              hideDeleteOfflineRpIcon
              ?
              null
              :
              <MenuLink
                leftIcon={availableOffline ? "bin" : "offline"}
                isRtl={isRtl}
                onClick={() => {
                  return availableOffline
                    ? 
                    (this.onRemoveFromOfflineClicked(book),
                    window.dataLayer.push({
                      event: gaEventActions.deletedFromLibrary,
                      category: this.props.eventCategory,
                      label: gaEventActions.offline_library,
                      item_type: null,
                      item_id: null,
                      item_value: null,
                      user_id: this.props.userId,
                      user_profile: this.props.profile.profile_type
                    }))
                    : isLoggedIn
                      ? offlineBooksCountForRead < MAX_OFFLINE_BOOKS_COUNT
                        ? (this.onAddToOfflineClicked(book),
                        window.dataLayer.push({
                          event: gaEventActions.savedStory,
                          category: this.props.eventCategory,
                          label: gaEventActions.offline_library,
                          item_type: null,
                          item_id: null,
                          item_value: null,
                          user_id: this.props.userId,
                          user_profile: this.props.profile.profile_type
                        }))
                        : this.onOpenModal('noSpaceForMoreOfflineBooks')
                      : addNotificationModal({
                        title: t("global.log-in"),
                        content: t("BookCard.please-log-in-notification-offline-library-text"),
                        additionalActions: [{
                          label: t('global.log-in'),
                          primary: true,
                          onClick: () => { removeNotificationModal(); openAuthModal(); }
                        }, {
                          label: t('global.sign-up'),
                          onClick: () => { removeNotificationModal(); openAuthModal(); }
                        }]
                      })
                }}
                label={availableOffline ? t("Book.remove-from-offline") : t("Book.add-to-offline")}
                loading={isSavingBookSlugs.includes(slug)}
                theme={availableOffline ? "danger" : null}
                legend={
                  availableOffline
                    ? null
                    : isLoggedIn
                      ? offlineBooksCountForRead < MAX_OFFLINE_BOOKS_COUNT
                        ? null
                        : t("Books.no-space-save-to-offline")
                      : null
                }
              />
              :
              null
            }
          </Menu>   
          )
        }
    }

    const originalAuthorEls = !book.isFromOfflineTranslate && originalAuthors ? getMetaEls(originalAuthors, baseClassName) : null;
    const authorEls = !book.isFromOfflineTranslate ? getMetaEls(authors, baseClassName) : null;
    const illustratorEls = !book.isFromOfflineTranslate ? getMetaEls(illustrators, baseClassName) : null;

    let awardIconEl;
    if (!book.isFromOfflineTranslate && ((contest && contest.won) || (awardsDetails && awardsDetails.length > 0))) {
      awardIconEl = <SvgIcon parentClassName={`${baseClassName}__award-icon`} name="badge" size={fontSize === 'l' ? 'm-ml' : 'm'}/>
    }

    let recommendationEl;
    if (recommended && !book.isFromOfflineTranslate) {
      recommendationEl = <div className={`${baseClassName}__recommendation`}><SvgIcon parentClassName={`${baseClassName}__recommendation-icon`} size={fontSize === 'l' ? 'sm' : 's'} name="verified"/> {t("global.verified")}</div>
    }

    let createdByChildEl;
    if (created_by_children) {
      createdByChildEl = <div className={`${baseClassName}__children-strip`}>{t("global.created-by-children")}</div>
    }

    let resourceEl;
    if (resource) {
      resourceEl = <div className={`${baseClassName}__resource-strip`}><SvgIcon name="resource" title={t("global.resources")} size="s"/>{t("global.resources")}</div>
    }

    let offlineDraftEl;
    if (book.isFromOfflineTranslate) {
      offlineDraftEl = <div className={`${baseClassName}__offline-draft`}>{t('OfflineTranslate.offline-draft')}</div>
    }

    let lastEditedEl;
    if (book.isFromOfflineTranslate && book.lastEdited) {
      lastEditedEl = <div className={`${baseClassName}__last-edited`}>{t('OfflineTranslate.last-edited')}: {book.lastEdited}</div>
    }

    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('language') || 'en';
    const bookPath = this.props.readSource === gaReadSource.stem ? links.stemBook(book.slug, window.location.pathname.replace(`/${siteLocale}`, '') === "/offline/stem-home" ? book.locale : lang) : links.storyDetails(slug).replace(`/${siteLocale}`, '');;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--level-${level}`]: level,
      [`${baseClassName}--font-size-${fontSize}`]: fontSize,
      [`${baseClassName}--disabled`]: disabled || loading,
      [`${baseClassName}--loading`]: loading,
      [`${baseClassName}--recommended`]: recommended,
      [`${baseClassName}--menu`]: menu,
      [`${baseClassName}--has-footer`]: recommended || (readsCount && !hideReadCountStat),
    }
    const titleClasses = {
      [`${baseClassName}__title`]: true,
      [`${baseClassName}__title--bhoti`]: book.language === 'Bhoti'
    }

    let awardTitle = ''
    if (awardsDetails && awardsDetails.length > 0 && contest && contest.won && contest.name) {
      awardTitle = `${t("BookCard.won")}: ${contest.name}\n${awardsDetails.map(award => award.description).join(',  ')}`
    } else if (contest && contest.won && contest.name) {
      awardTitle = `${t("BookCard.won")}: ${contest.name}`
    } else if (awardsDetails && awardsDetails.length > 0) {
      awardTitle = `${awardsDetails.map(award => award.description).join(',  ')}`
    }

    return (
      <div className={classNames(classes)}>
        { this.state.showJoyride ?
            <Suspense fallback={null}>
              <Joyride
                steps={[
                  {
                    target: `#offline-library`,
                    content:  <div  dir={isRtl ? "rtl" : "ltr"} className={`${baseClassName}__tooltip-wrapper`}> 
                                <div className={`${baseClassName}__tooltip-image`}>
                                  <SvgIcon name="sw-logo" size="m-ml"/>
                                </div>                                                            
                                <div className={`${baseClassName}__tooltip-content`}>
                                  <b>{t('global.draft-saved')} !</b>                           
                                  <p>{t('Book.added-intermediate-draft-notification')}</p>
                                  <p>{t('Book.added-intermediate-draft-notification-2')}</p>
                                  <Link href = {links.offlineTranslateBooks()} onClick={() => localStorage.setItem("offlineTranslateRedirect", true)}>
                                    <SvgIcon name="offline" size="m"/> {t('global.go-to-offline-library')}                                
                                  </Link>
                                </div>                              
                              </div>,
                    placement: 'bottom',
                    offset :"0",
                    disableBeacon: true,                
                  },
                ]}
                showSkipButton={false}
                hideBackButton={true}
                disableScrollParentFix={true}
                scrollDuration={20}
                scrollToFirstStep={true}
                disableOverlayClose={true}
                disableCloseOnEsc={true}
                callback={this.handleJoyrideCallback}
                locale={{last:"Ok!"}} 
                floaterProps= {{
                  disableAnimation: true,
                }}
                styles={{
                  overlay: { 
                    backgroundColor: 'none',
                    cursor: "auto",
                    mixBlendMode: 'unset'},
                  spotlight: {
                    backgroundColor: 'none',
                    boxShadow: '0px 0px 0px 9999px rgba(0,0,0,0.5)',
                  },
                  buttonNext: { display: 'none' },
                  tooltipContent: { padding: '10px',
                                    marginBottom: '-16px' },
                }}      
              />
            </Suspense>
          : null
        }
        <LazyFontLoader languages={[language]} />
        <div className={`${baseClassName}__container`} onClick={isFromMobileTranslate ? this.toggleOverlay : null}>
          <div className={`${baseClassName}__wrapper`}>
            <div className={`${baseClassName}__image-wrapper`} href={bookPath}>
              <div className={`${baseClassName}__image`}>
                <Img
                  image={coverImage}
                  alt={title}
                  lazyLoad
                  sizes={imageSrcsetSizes.grid2up6up}
                  offline={offline} />
              </div>
              {
                //After viewport large we show Quick View Button on hover, so we don't need image overlay(which comes for 3 dot menu)
                (awardIconEl || shouldDisplayMenu) && !viewport.large
                ?
                <div className={`${baseClassName}__image-overlay`}></div>
                :
                null
              }
              {awardIconEl}
            </div>

            <div className={`${baseClassName}__meta-wrapper`}>
              {createdByChildEl}
              {
                flpBook ?
                <div className={`${baseClassName}__flp-level-strip`}>
                  {
                    language
                    ?
                    <span className={`${baseClassName}__language`}>{language}</span>
                    :
                    null
                  }
                  <span className={`${baseClassName}__level`}>{flpLevel}</span>                  
                </div>
                :
                <div className={`${baseClassName}__level-strip`} href={bookPath}>
                  {
                    language
                    ?
                    book.isFromOfflineTranslate
                      ?
                      (<span className={`${baseClassName}__language`}>{book.targetLanguage}</span>)
                      :                  
                      (<span className={`${baseClassName}__language`}>{language}</span>)
                    :
                    null
                  }
                  <span className={`${baseClassName}__level`}>{t("global.level", 1)} {level === "5" ? 1  : level } </span>
                  { level === "5" && <span className={`${baseClassName}__level-side-text`}>{t("global.emergent-readers")}</span>}
                </div>
              }
              <div className={`${baseClassName}__meta`}>
                <h3  dir={isTextRtl(title) ? "rtl" : "ltr"} className={classNames(titleClasses)}>{title}</h3>
                {
                  (isTranslation || isRelevelled) || originalAuthorEls
                    ?
                  <div>
                    {originalAuthorEls}
                    {illustratorEls}
                    {authorEls}
                  </div>
                    :
                  <div>
                    {authorEls}
                    {illustratorEls}
                    {lastEditedEl}
                  </div>
                }
                <div className={`${baseClassName}__footer`}>
                  {recommendationEl}
                  {offlineDraftEl}
                  {
                    !readsCount || hideReadCountStat
                    ?
                    null
                    :
                    <Stat
                      parentClassName={`${baseClassName}__read-stat`}
                      icon="book"
                      value={readsCount}
                      size="s" />                    
                  }
                </div>
                {resourceEl}
              </div>
            </div>
            {!isFromMobileTranslate && <Link
              isInternal={onClick ? false : true}
              parentClassName={`${baseClassName}__link`}
              href={bookPath}
              title={!book.isFromOfflineTranslate ? awardTitle : ''}
              onClick={(e) => {this.onRecoCardClick(secClicked); if(onClick) this.handleClick(e);   
              }}
              >{title}</Link>}
          </div>

            { menu
              ?
              <MenuEl
                baseClassName={baseClassName}
                menu={menu}
                disabled={disabled || loading}
                viewport={viewport}
                book={book}
                t={t}
                onMenuButtonClick={(showTranslateButton || isFromMobileTranslate) ? this.onTranslateBookClicked.bind(this, slug) : openGlobalQuickView.bind(this, book, readSource, eventCategory ? eventCategory : readSource, this.props.isSupplementary)}
                hideMenu={hideMenu}
                hideQuickViewBtn={hideQuickViewBtn}
                shouldShowReadIcon={shouldShowReadIcon}
                showReadIconLoader={showReadIconLoader}
                isFetchingAssets={isFetchingAssets}
                isListenIconClicked={this.state.isListenIconClicked}
                onAudioReadIconClicked={this.onAudioReadIconClicked.bind(this, sectionClicked.bookCardIcon, readSource)}
                isReadIconClicked={this.state.isReadIconClicked}
                onBookReadIconClicked={this.onBookReadIconClicked.bind(this, sectionClicked.bookCardIcon, readSource)}
                onResourceIconClicked={this.onResourceIconClicked}
                showTranslateButton={showTranslateButton}
                isFromMobileTranslate={isFromMobileTranslate}
                showOverlay={this.state.showOverlay}
                closeOverlay={this.toggleOverlay}
                isDraftLoading={isDraftLoading}
                isCheckingTranslations={isCheckingTranslations}
                isCheckingMobileTranslations={isCheckingMobileTranslations}
                isTranslateOfflineClicked={this.state.isTranslateOfflineClicked}
                onSaveForOfflineTranslate={offlineBooksCountForTranslate < MAX_OFFLINE_BOOKS_COUNT ? this.onSaveForOfflineTranslate.bind(this, book) : this.onOpenModal.bind(this, 'noSpaceForMoreOfflineBooks')}
                isSavingOfflineTranslations={isSavingTranslateBookSlugs.includes(book.slug)}
                hideReadalong={hideReadalong}
                hideAllIcons={hideAllIcons}
                userId={userId}
                userType={profile.profile_type}
                readSource={readSource}
                eventCategory={this.props.eventCategory}
                linkLoading={this.state.linkLoading}
                resource={resource}
                eventLabel={eventLabel}
                showEmbedHoverIcons={showEmbedHoverIcons}
                />
              :
              null
            }

          {(hasOverlay || hasLightOverlay) && <div className={`${baseClassName}__overlay ${baseClassName}__overlay${hasLightOverlay ? '--faded' : ''}`} />}


           {
              this.state.isModalVisible.noSpaceForMoreOfflineBooks
              ?
              <Suspense fallback={null}>
                <NoSpaceForMoreOfflineBooksModal
                  viewport={viewport}
                  onClose={() => this.onCloseModal('noSpaceForMoreOfflineBooks')}
                  maximum={MAX_OFFLINE_BOOKS_COUNT}
                  isRtl={isRtl}
                />
              </Suspense>
              :
              null
           }
        </div>
        {
          this.state.isModalVisible.selectBookShelf
          ?
          <Suspense fallback={null}>
            <SelectBookShelf
              isVisible={this.state.isModalVisible.selectBookShelf}
              onCloseClicked={() => this.onCloseModal('selectBookShelf')}
              slug={slug}
              viewport={viewport}
              addSlimNotification={addSlimNotification}
              isRtl={isRtl}
              isLoggedIn={isLoggedIn}
              userEmail={userEmail}
              userId={userId}
              userType={this.props.userType}
              isFetchingBookShelves = {isFetchingBookShelves}
              bookShelfArr = {bookShelfArr}
              addBookshelfWorkflow={addBookshelfWorkflow}
              addNewBookToBookshelfWorkflow={addNewBookToBookshelfWorkflow}
              getBookshelfAutocompletefWorkflow={getBookshelfAutocompletefWorkflow}
              getBookshelfListWorkflow={getBookshelfListWorkflow}
              userBookshelves={userBookshelves}
              fromCard
              fetchUserListsWorkflow={fetchUserListsWorkflow}
              loading={this.props.isLoading}
              eventCategory={this.props.eventCategory}
            />
          </Suspense>
         :
         null
        }
        {
          this.state.openPdf &&
          <Suspense fallback={null}>
            <PdfReader 
              pdfFile={this.state.pdfFile}
              viewport={viewport}
              onClose={() => this.openPdfViewer('')}
            />
          </Suspense>  
        }
      </div>
    );
  }
}

BookCard.propTypes = {
  book: PropTypes.object,
  title: PropTypes.string,
  language: PropTypes.string,
  level: PropTypes.string,
  slug: PropTypes.string,
  coverImage: PropTypes.object,
  recommended: PropTypes.bool,
  authors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired
  })),
  fontSize: PropTypes.oneOf([
    'm',
    'l'
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  shouldDisplayMenu: PropTypes.bool,
  contest: PropTypes.object,
  offline: PropTypes.bool
};

export default withRouter(BookCard);



// WEBPACK FOOTER //
// ./src/components/BookCard/BookCard.jsx